import { createIntl } from '@gravity-ui/i18n-react';
import i18nConfig from './i18n.config';

const getDefaultLocale = (): string => {
    const savedLocale = localStorage.getItem('vzhik-locale');
    if (savedLocale) {
        return savedLocale;
    }

    const browserLocale = navigator.language.toLowerCase();

    for (const allowedLocale of i18nConfig.allowedLocales) {
        if (browserLocale.startsWith(allowedLocale.toLowerCase())) {
            return allowedLocale;
        }
    }

    return i18nConfig.defaultFallback;
};

export const intl = createIntl({
    allowedLocales: [...i18nConfig.allowedLocales],
    fallbackLocales: i18nConfig.fallbackLocales,
    defaultFallback: i18nConfig.defaultFallback,
    locale: getDefaultLocale(),
    defaultRichTextElements: {
        p: (chunks) => <p>{chunks}</p>,
        a: (chunks) => <a>{chunks}</a>,
    },
    onError: (error) => {
        console.error('i18n error:', error);
    },
    wrapRichTextChunksInFragment: true,
});

export const getCurrentLocale = (): string => {
    return localStorage.getItem('vzhik-locale') ?? getDefaultLocale();
};

export const setLocale = (locale: string) => {
    localStorage.setItem('vzhik-locale', locale);
    window.location.reload();
};
